// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4bb39b01","422":"8017f441","558":"c2e6e31b","574":"c74e0856","654":"8f900892","671":"ff9b275a","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};